<template>
    <div class="course-item-vertical">
        <router-link class="course-item-vertical__router-link" :to="isExpired || isWatchListItemInEditMode ? '' : getRouteToCourse(course)">
            <div class="course-item-vertical__image-box">
                <ThumbnailBackgroundImage :course="course" isVertical />
                <ThumbnailForegroundLogo :course="course" />
                <ThumbnailPartnerLogo :course="course" />
                <ThumbnailInstructors :course="course" />
            </div>
            <div class="course-item-vertical__info-box">
                <span class="course-item-vertical__title">{{ course.title | truncate(140)}}</span>
                <ThumbnailInfoTable itemType="course" :entity="course" />
                <div class="course-item-vertical__description">
                    <span class="-v-html" v-html="truncateDescription"></span>
                </div>
                <ThumbnailVerticalDetails itemType="course" :course="course" />
                <ThumbnailTags :course="course" />
                <TotemLockIcon v-if="userHasNoAccess" isVertical />
                <CourseProgressBar
                    v-if="course.progressPercentage && course.progressPercentage !== 0 && course.progressPercentage !== 100"
                    :progress="course.progressPercentage"
                    :isCompleted="course.progressPercentage === 100"
                    :isCourseListItem="true"
                    :isVertical="true"
                />
            </div>
        </router-link>
        <TotemAddToWatchlistButton
            :isVertical=true
            v-if="showAddToFavourite"
            :elementId="course.id"
        />
    </div>
</template>

<script>
    import CourseItemHelper from 'components/shared/global-courses-items/helper/course-item-helper'
    import ThumbnailInfoTable from 'components/shared/global-courses-items/thumbnails/ThumbnailInfoTable.vue'
    import ThumbnailTags from 'components/shared/global-courses-items/thumbnails/ThumbnailTags.vue'
    import ThumbnailInstructors from 'components/shared/global-courses-items/thumbnails/ThumbnailInstructors.vue'
    import ThumbnailVerticalDetails from 'components/shared/global-courses-items/thumbnails/ThumbnailVerticalDetails.vue'
    import ThumbnailPartnerLogo from 'components/shared/global-courses-items/thumbnails/ThumbnailPartnerLogo.vue'
    import ThumbnailForegroundLogo from 'components/shared/global-courses-items/thumbnails/ThumbnailForegroundLogo.vue'
    import ThumbnailBackgroundImage from 'components/shared/global-courses-items/thumbnails/ThumbnailBackgroundImage.vue'
    import CourseProgressBar from 'components/coursepage/courseaddons/CourseProgressBar'

    export default {
        name: 'totem-course-item-vertical',
        components: {
            ThumbnailInfoTable,
            ThumbnailTags,
            ThumbnailInstructors,
            ThumbnailVerticalDetails,
            ThumbnailPartnerLogo,
            ThumbnailForegroundLogo,
            ThumbnailBackgroundImage,
            CourseProgressBar
        },
        mixins: [ CourseItemHelper ]
    }
</script>

<style lang="scss" scoped>
    @include totem_thumbnail_item_vertical;
</style>
